module.exports = __webpack_public_path__ + "static/media/Benu-Mobile-Scroll-Demo.8478d78c.m4v";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wizard/Benu-Mobile-Scroll-Demo.m4v
// module id = 1502
// module chunks = 0